export default __webpack_public_path__ + "static/media/checkbox-bird-black.18f4b71d.svg";